// ligfrontend/src/components/Lig/LigLandingComponent.jsx
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { memberAPI } from "../../services/api";
import { useAuth } from "../../context/AuthContext";
import LoadingSpinner from "../common/LoadingSpinner";
import "./LigLandingComponent.css";

const LigLandingComponent = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [userName, setUserName] = useState("");
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    checkFamily();
  }, []);

  const checkFamily = async () => {
    try {
      setChecking(true);
      const family = await memberAPI.getFamily();

      if (family.length > 0) {
        // User already has a family, redirect
        navigate("/lig");
      }
    } catch (error) {
      console.error("Error checking family:", error);
      // If error, assume no family exists and show landing page
    } finally {
      setChecking(false);
    }
  };

  const handleStart = async () => {
    if (!userName.trim()) return;

    try {
      setLoading(true);
      await memberAPI.createFamily(userName.trim());
      navigate("/lig");
    } catch (error) {
      console.error("Error creating family:", error);
      // Show error to user
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && userName.trim()) {
      handleStart();
    }
  };

  if (checking) {
    return <LoadingSpinner message="Checking your account..." />;
  }

  return (
    <div className="liglanding-container">
      <div className="landing-content">
        <div className="landing-card">
          <div className="landing-icon">🌟</div>

          <h1 className="landing-title">Welcome to Life is Good!</h1>

          <p className="landing-subtitle">
            Start documenting the moments that make life beautiful
          </p>

          <div className="landing-divider"></div>

          <div className="landing-form">
            <h2 className="form-heading">Let's get started</h2>
            <p className="form-description">What does your family call you?</p>

            <div className="form-group">
              <input
                type="text"
                className="landing-input"
                placeholder="Enter your nickname"
                value={userName}
                onChange={(e) => setUserName(e.target.value)}
                onKeyPress={handleKeyPress}
                autoFocus
                maxLength={50}
              />
            </div>

            <button
              className="btn-start"
              onClick={handleStart}
              disabled={!userName.trim() || loading}
            >
              {loading ? "Creating Your Family..." : "Start My Journey"}
            </button>
          </div>

          <div className="landing-features">
            <div className="feature">
              <span className="feature-icon">📝</span>
              <span className="feature-text">Document daily moments</span>
            </div>
            <div className="feature">
              <span className="feature-icon">👨‍👩‍👧‍👦</span>
              <span className="feature-text">Share with family</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🎉</span>
              <span className="feature-text">Celebrate life together</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LigLandingComponent;
